// extracted by mini-css-extract-plugin
export default {"ViewAll":"CardDeals_ViewAll__Y2NiY","CardDeals":"CardDeals_CardDeals__NjEwM"};